module.exports = __webpack_public_path__ + "static/physics-of-the-future-25835986690a49ff57b3475b0799945d.jpg";